/* eslint object-curly-newline: */
import { LOCATION_CHANGE } from '../actions';
import {
  SET_NODE_ISSUES_SELECTED,
  SET_NODE_ISSUES_FILTERED,
  SET_NODE_ISSUES_SELECTED_FOR_ACK,
  SORT_NODE_ISSUE_TABLE,
  SET_NODE_ISSUE_SEARCH
} from '../actions/nodeIssues';

/**
 * Structure design
 * nodeHealthPage:        -> root
 *     selected:          -> array of selected table data
 */
const initialState = {
  selected: [],
  selectedForAck: [],
  filtered: {
    nodes: ['all'],
    issueTypeIds: ['all'],
    jobNames: ['all']
  },
  sortedColumn: undefined,
  search: ''
};


const nodeHealthPage = (state = initialState, action) => {
  switch (action.type) {
    case LOCATION_CHANGE:
      if (!action.payload ||
        !action.payload.search ||
        action.payload.pathname !== '/node-health') {
        return state;
      }

      // parse selected nodes for sharing
      return state;
    case SET_NODE_ISSUES_SELECTED:
      const newState = {
        ...state,
        selected: action.selected || []
      };
      return newState;
    case SET_NODE_ISSUES_SELECTED_FOR_ACK:
      const newAckState = {
        ...state,
        selectedForAck: action.selectedForAck || []
      };
      return newAckState;
    case SET_NODE_ISSUES_FILTERED:
      const newFilterState = {
        ...state,
        filtered: {
          nodes: action.filtered.nodes || [],
          issueTypeIds: action.filtered.issueTypeIds || [],
          jobNames: action.filtered.jobNames || []
        }
      };
      return newFilterState;
    case SORT_NODE_ISSUE_TABLE:
      return {
        ...state,
        sortedColumn: action.sortingKey
      };
    case SET_NODE_ISSUE_SEARCH:
      const newSearchState = {
        ...state,
        search: action.searched || ''
      };
      return newSearchState;
    default:
      return state;
  }
};

export default nodeHealthPage;

const getNodeHealthPage = state => state.nodeHealthPage;
export const getNodeHealthSelectedSummaryCells = state =>
  getNodeHealthPage(state).selected;
export const getNodeHealthInfo = state =>
  getNodeHealthPage(state).filtered;
export const getNodeHealthSelectedForAck = state =>
  getNodeHealthPage(state).selectedForAck;
export const getNodeHealthSortedColumn = state =>
  getNodeHealthPage(state).sortedColumn;
export const getNodeHealthPageSearch = state =>
  getNodeHealthPage(state).search;


// WEBPACK FOOTER //
// src/reducers/nodeHealthPage.js